import { NO_TIP_PAYMENT_METHOD_SELECTED } from '~shared/features/checkout/constants';
import { isValidPaymentMethod } from '~shared/features/checkout/helpers';
import { getIsOrderBundling } from '~shared/features/checkout/selectors/getCheckoutFlow';
import { getIsOrderPayWithApplePay, getOrder } from '~shared/features/checkout/selectors/getOrder';
import { type ValidationError } from '~shared/features/checkout/types';
import { useOrderPricing } from '~shared/queries';
import { useGetPaymentMethods } from '~shared/queries/query-keys/paymentMethods';
import { useSelectorShared } from '~shared/store';

export const useCheckoutTipErrors = () => {
  const order = useSelectorShared(getOrder);
  const { tip_amount: tipAmount, tip_payment_method_id: tipPaymentMethodID } = order;
  const { paymentMethods, isSuccess } = useGetPaymentMethods();
  const isPaidWithApplePay = useSelectorShared(getIsOrderPayWithApplePay);
  const { hasAppliedDeliveryFee } = useOrderPricing();
  const isOrderBundling = useSelectorShared(getIsOrderBundling);

  const errors: ValidationError[] = [];

  const hasTip = (tipAmount ?? 0) > 0;
  const isTipOrFeePaymentMethodRequired = !isOrderBundling && (hasTip || hasAppliedDeliveryFee);
  const cannotChargeTipPaymentMethod = !isValidPaymentMethod(tipPaymentMethodID, paymentMethods);

  if (isSuccess && isTipOrFeePaymentMethodRequired && cannotChargeTipPaymentMethod && !isPaidWithApplePay) {
    if (hasTip && hasAppliedDeliveryFee) {
      errors.push({
        key: NO_TIP_PAYMENT_METHOD_SELECTED,
        message: 'Please select a payment method for your tip & delivery fee.',
      });
    } else if (hasTip) {
      errors.push({
        key: NO_TIP_PAYMENT_METHOD_SELECTED,
        message: 'Please select a payment method for your courier tip.',
      });
    } else if (hasAppliedDeliveryFee) {
      errors.push({
        key: NO_TIP_PAYMENT_METHOD_SELECTED,
        message: 'Please select a payment method for your delivery fee.',
      });
    }
  }

  return { tipValidationErrors: errors };
};
